import React, {Suspense} from 'react';


import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { range } from 'lodash-es';
import LoadingLogo from './common/LoadingLogo'
import DownloadButtonsSection from './common/DownloadButtonsSection'
import ScrollAnimatedInlineVideoContainer from './common/ScrollAnimatedInlineVideoContainer'
import AutoPlayInlineVideoContainer from './common/AutoPlayInlineVideoContainer'
import ScrollAnimatedHeroImageContainer from './common/ScrollAnimatedHeroImageContainer'
import PieChartInsightSection from './common/PieChartInsightSection'
import LineGraph from './common/LineGraph'
import NeuroFitProgressRing from './common/NeuroFitProgressRing'
import MembershipFeatureDescription from './common/MembershipFeatureDescription'
import AppReviewPanel from './common/AppReviewPanel'
import FaqSection from './common/FaqSection'
import LandingPageLinksModal from './modals/LandingPageLinksModal'
import QrCodeDownloadModal from './modals/QrCodeDownloadModal'

import { Scrollama, Step } from 'react-scrollama';
import { animateScroll } from 'react-scroll'


import { history } from '../history'

import {
  subdomainUrls,
  recordSignupFunnelEventGA,
  NeuroFitUniversalAppStoreLink,
  NeuroFitAppleAppStoreLink,
  NeuroFitGooglePlayStoreLink,
  ProductionBaseUrl,
  ProductionProductDemoBaseUrl,
  delay,
  DefaultAspectRatio,
  recordLinkClickAndRedirect,
  recordPixelEventIfAvailable,
  getCurrentYear,
  MinDesktopWidthPixels,
  preloadImagePaths,
  initializePixelIfAvailable,
  isProduction,
  onceEventListener,
  isFirefox,
} from '../utils'

import {
  AppleSvg,
  AndroidSvg,
  HamburgerSvg,
  NeuroFitCutoutSvg,
  NeuroFitNamedLogoSvg,
} from '../constants/svgs'

import {
  GA_LABEL_CLICKED_APP_DOWNLOAD_LINK,
  GA_LABEL_CLICKED_WORKSHOP_BUTTON,
  GA_LABEL_CLICKED_CERTIFICATION_BUTTON,
  GA_LABEL_CLICKED_QUIZ_BUTTON,
} from '../constants/gaEventLabels'

import StarRatings from 'react-star-ratings';

import Helmet from './common/Helmet'

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}

const getRandomPadding = () => {
  const basePaddingPixels = 5
  const deviationPaddingPixels = 5
  return `${basePaddingPixels + Math.random() * deviationPaddingPixels}px ${basePaddingPixels + Math.random() * deviationPaddingPixels}px ${basePaddingPixels + Math.random() * deviationPaddingPixels}px ${basePaddingPixels + Math.random() * deviationPaddingPixels}px`
}

const HealthProfessionals = [
  {name: "Doctors", animationDelayMs: 0, fontSize: "min(5vw, 22px)", padding: getRandomPadding()},
  {name: "Therapists", animationDelayMs: 600, fontSize: "min(5vw, 22px)", padding: getRandomPadding()},
  {name: "Fitness Trainers", animationDelayMs: 300, fontSize: "min(3.5vw, 15px)", padding: getRandomPadding()},
  {name: "Holistic Health Coaches", animationDelayMs: 2400, fontSize: "min(4vw, 18px)", padding: getRandomPadding()},
  {name: "Yoga Teachers", animationDelayMs: 900, fontSize: "min(4vw, 18px)", padding: getRandomPadding()},
  {name: "Neuromuscular Therapists", animationDelayMs: 1800, fontSize: "min(3.5vw, 15px)", padding: getRandomPadding()},
  {name: "Chiropractors", animationDelayMs: 1500, fontSize: "min(5vw, 22px)", padding: getRandomPadding()},
  {name: "Physical Therapists", animationDelayMs: 2100, fontSize: "min(4vw, 18px)", padding: getRandomPadding()},
  {name: "Military Nurses", animationDelayMs: 2700, fontSize: "min(5vw, 22px)", padding: getRandomPadding()},
  {name: "Pilates Instructors", animationDelayMs: 1200, fontSize: "min(4vw, 18px)", padding: getRandomPadding()},
  {name: "And many more...", animationDelayMs: 1200, fontSize: "min(4vw, 18px)", padding: getRandomPadding()}
]

const IOS_16 = 16
// Smaller MP4 file size: has one keyframe every 5 frames. 
// Works on Desktop + iOS 16 Devices.
const OPTIMIZED_PHONE_ANIMATION_VIDEO = "/assets/animations/lp-phone-flip/phone-kf-5-silver-hero-final.mp4"
// Optimized file does not work on iOS < 16, so use full-sized file instead.
const FULL_SIZE_PHONE_ANIMATION_VIDEO = "/assets/animations/lp-phone-flip/phone-kf-5-silver-hero-final-ios-faststart-baseline-cv.mp4"

const frameIndexesForStep = {
  1: 0.92,
  2: 0.94,
  3: 0.96,
  4: 0.98,
  5: 1.0
}

const getCurrentHeroVideoProgress = (currentStepIndex, currentStepProgress) => {
  if (currentStepIndex === 0) {
    return Math.min(Math.max((-0.1 + currentStepProgress*1.1), 0), 0.92)
  } else if (currentStepIndex >= 1 && currentStepIndex <= 5) {
    return frameIndexesForStep[currentStepIndex]
  } else {
    return 1.0
  }
}

const LaurelImagePaths = [
  "/images/shape-groundbreaking-recovery-innovations-white.webp?v=3",
  "/images/well-and-good-laurel-white.webp?v=2"
]

class LandingPageV2 extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      showAnswer: {},
      showSettingsModal: false,
      showQrCodeModal: false,
      headerBackgroundColor: "transparent",
      dropShadowColor: "transparent",
      topPageScrollProgress: 0,
      totalPagesScrollProgress: 0,
      headerBorderColor: "transparent",
      headerBackgroundBlur: "none",
      heroBackdropFilter: "none",
      heroOverlayColor: "transparent",
      logoOutlineColor: "#EDEEF2",
      show: true,
      showIframe: false,
      isVideoLoaded: false,
      isHeroLoaded: false,
      isHeroLoadingComplete: false,
      videoOpacity: 1.0,
      currentHeaderIndex: -1,
      storyLoadingLength: 3500,
      heroVideoDownloadProgress: 0,
      manualStartRef: React.createRef(),
      hasScrolled: false,
      currentStepIndex: 0,
      currentStepProgress: 0
    }
  }

  triggerHeroLoadCompletion() {
    this.setState({isHeroLoaded: true, heroVideoDownloadProgress: 1})

    // Preload Laurel + University Logos once hero video has loaded.
    preloadImagePaths(LaurelImagePaths)
    preloadImagePaths([
      "/assets/animations/lp-phone-flip/phone-silver-program.webp"
    ])
    setTimeout(() => {
      this.setState({
        isHeroLoaded: true,
        heroVideoDownloadProgress: 1,
        isHeroLoadingComplete: true
      })
    }, 1000)
  }

  render() {

    const {
      safeAreaInsets,
      innerHeight,
      isIOSDevice,
      isAndroidDevice,
      iOSVersion
    } = this.props

    const {show, showAnswer, showSettingsModal, currentStepIndex, currentStepProgress, showQrCodeModal, scrollingContainerRef, headerBackgroundColor, heroVideoDownloadProgress, isHeroLoaded, isHeroLoadingComplete} = this.state

    const innerWidth = document.body.clientWidth || window.innerWidth

    const isMobile = innerWidth <= MinDesktopWidthPixels
    const isDesktop = innerWidth >= MinDesktopWidthPixels

    const phoneAspectRatio = 1841 / 907

    const currentYear = getCurrentYear()

    const appDownloadUrl = isIOSDevice ? NeuroFitAppleAppStoreLink : (isAndroidDevice ? NeuroFitGooglePlayStoreLink : NeuroFitUniversalAppStoreLink)

    const heroVideoSizePixels = Math.min(Math.min(700, innerWidth), innerHeight * 0.55)

    const currentHeroVideoProgressPct = getCurrentHeroVideoProgress(currentStepIndex, currentStepProgress)

    const phoneAnimationVideoPath = (isDesktop || (isIOSDevice && (!!iOSVersion) && iOSVersion.major === IOS_16)) ? OPTIMIZED_PHONE_ANIMATION_VIDEO : FULL_SIZE_PHONE_ANIMATION_VIDEO

    return (
      <div style={{height: innerHeight, pointerEvents: isHeroLoadingComplete ? "all" : "none"}}>
        <Helmet
          title={"NEUROFIT App Product Demo"}
          description={"Product Demo Page For NEUROFIT - the industry-leading nervous system regulation app, available for iOS and Android."}
          href={ProductionProductDemoBaseUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#000000"}}>
          <div style={{position: "fixed", top: 0, textAlign: "start", width: "100vw", height: innerHeight - 120, zIndex: -1}}>
            {((isIOSDevice || isDesktop) && !isFirefox) ? (
              <div style={{color: "black", width: heroVideoSizePixels, height: heroVideoSizePixels, transition: "opacity 200ms linear", opacity: (currentStepIndex <= 5) ? 1 : 0, transform: `scale(${currentStepIndex > 0 ? 1.2 : Math.min(1.2, 1 + currentStepProgress*2)}) translateY(${currentStepIndex > 0 ? 30 : Math.min(30, currentStepProgress * 300)}px)`, margin: "0px auto", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
                <div style={{width: "100%", height: "100%", transition: "all 500ms ease-in 400ms", opacity: isHeroLoaded ? 1 : 0, transform: isHeroLoaded ? "none" : "scale(0.7) translateY(-30px)"}}>
                  <ScrollAnimatedInlineVideoContainer
                    videoPath={phoneAnimationVideoPath}
                    videoPosterPath={"/assets/animations/lp-phone-flip/phone-silver-poster.webp"}
                    widthPixels={heroVideoSizePixels}
                    aspectRatio={1}
                    isVideoVisible
                    currentProgressPct={currentHeroVideoProgressPct}
                    baseContentUrl={ProductionBaseUrl}
                    onVideoLoad={() => {
                      this.triggerHeroLoadCompletion()
                    }}
                    onDownloadProgress={(progress) => {
                      if (!isHeroLoaded) {
                        this.setState({heroVideoDownloadProgress: progress, isHeroLoaded: progress >= 1})
                      }
                    }}
                    hideLoadingAnimation
                    hideLoadedAnimation
                    registerManualStartEvent={triggerManualVideoStart => {
                      // Ensure Hero Video becomes controllable on iOS in Low Power Mode.
                      onceEventListener(window, "touchstart", function (e) {
                        triggerManualVideoStart()
                      });
                      // Ensure Hero Video becomes controllable on MacOS Safari in Low Power Mode.
                      onceEventListener(this.scrollingContainerRef, "scroll", function (e) {
                        triggerManualVideoStart()
                      });
                    }}
                    isIOSDevice={isIOSDevice}
                    isAndroidDevice={isAndroidDevice}
                  />*
                </div>
              </div>
            ) : (
              <div style={{color: "black", width: heroVideoSizePixels, height: heroVideoSizePixels, transition: "opacity 200ms linear", opacity: (currentStepIndex <= 5) ? 1 : 0, transform: `scale(${currentStepIndex > 0 ? 1.2 : Math.min(1.2, 1 + currentStepProgress*2)}) translateY(${currentStepIndex > 0 ? 30 : Math.min(30, currentStepProgress * 300)}px)`, margin: "0px auto", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
                <div style={{width: "100%", height: "100%", transition: "all 500ms ease-in 400ms", opacity: isHeroLoaded ? 1 : 0, transform: isHeroLoaded ? "none" : "scale(0.7) translateY(-30px)"}}>
                  <ScrollAnimatedHeroImageContainer
                    featureImagePaths={[
                      "/assets/animations/lp-phone-flip/phone-silver-program.webp",
                      "/assets/animations/lp-phone-flip/phone-silver-smart-exercises.webp",
                      "/assets/animations/lp-phone-flip/phone-silver-hrv.webp",
                      "/assets/animations/lp-phone-flip/phone-silver-insights.webp",
                      "/assets/animations/lp-phone-flip/phone-silver-clear.webp"
                    ]}
                    heroImagePath={"/assets/animations/lp-phone-flip/phone-silver-poster.webp"}
                    currentImageIndex={currentStepIndex}
                    currentImageProgress={currentStepProgress}
                    onHeroImageLoad={() => {
                      this.triggerHeroLoadCompletion()
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <div style={{position: "fixed", top: 0, padding: "calc(30px) 0px", textAlign: "start", width: "100vw", height: innerHeight - 120, zIndex: -1}}>
            <div style={{color: "black", transition: "opacity 200ms linear", opacity: (currentStepIndex > 5 && currentStepIndex <= 10) ? 1 : 0, margin: "0px auto", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
              <NeuroFitCutoutSvg
                size={"min(12vw, 60px)"}
                color={"#FFFFFF"}
              />
            </div>
          </div>
          <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, right: 0, backgroundColor: showSettingsModal ? "rgba(0, 0, 0, 0.5)" : "transparent", pointerEvents: "none", transition: "all 300ms ease-out", transitionProperty: "background-color", zIndex: 2000}}>
          </div>
          <CSSTransition
            in={isHeroLoaded}
            timeout={1000}
            classNames={"slide-from-bottom-fade-in"}
            unmountOnExit
            onExited={() => {}}
          >
            <div style={{position: "fixed", left: 0, bottom: 0, right: 0, paddingBottom: "1.5vh", zIndex: 0, display: "flex", justifyContent: "center"}}>
              <div style={{width: "85%", maxWidth: 700}}>
                <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                  <a
                    href="/"
                    target="_blank"
                    style={{display: "flex", cursor: "pointer", pointerEvents: "all", textDecoration: "none", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: "4vh", color: "#FFFFFF", backgroundColor: "#000000", padding: "18px 15px", border: "2px #FFFFFF solid"}}
                  > 
                    {"DOWNLOAD THE APP"}
                  </a>
                </div>
                <div
                  className={"landing-down-arrow" + (((currentStepIndex > 0) || (currentStepProgress > 0)) ? " landing-down-arrow-collapsed" : "")}
                  style={{display: "flex", marginTop: "1vh", justifyContent: "center", width: "100%"}}
                  onClick={() => {
                    console.log(animateScroll)
                    console.log(animateScroll.scrollTo(innerHeight * 1.5, {
                      duration: 1200,
                      delay: 100,
                      smooth: true,
                      containerId: 'landing-page-container'
                    }))
                  }} 
                >
                  <svg style={{cursor: "pointer", pointerEvents: "all", height: 40, width: 40}} className="loading-pulse-animation-down-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" version="1.1" x="0px" y="0px"><g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g fill="#FFFFFF"><path d="M20,27.4142136 L32.7071068,14.7071068 L31.2928932,13.2928932 L20,24.5799999 L8.70710678,13.2928932 L7.29289322,14.7071068 L20,27.4142136 Z"></path></g></g></svg>
                </div>
              </div>
            </div>
          </CSSTransition>
          <div 
            id={"landing-page-container"}
            className={"disable-scrollbars"}
            ref={elem => this.scrollingContainerRef = elem}
            style={containerStyle}
          >
            <div id="scrollama-container" style={{ marginBottom: '100vh'}}>
              <div style={{position: "fixed", top: 0, textAlign: "start", width: "100vw", height: innerHeight - 120, zIndex: -1}}>
                {(currentStepIndex === 0) && (
                  <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                    <div>
                      <div style={{marginTop: `calc(${0.4 * heroVideoSizePixels}px - min(24vw, 100px))`, transform: `translateY(${-0.6 * currentStepProgress * innerHeight}px)`, opacity: Math.max(0, 1 - currentStepProgress)}}>
                        <div style={{color: "#FFFFFF", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
                          <div style={{width: "85%", maxWidth: 400, letterSpacing: `${currentStepProgress / 2 + 0.065}em`, transform: isHeroLoaded ? "none" : "scale(0.8) translateY(50px)", opacity: isHeroLoaded ? 1 : 0.8, transition: "opacity 500ms ease-in 400ms, transform 500ms ease-in 400ms", fontFamily: "Futura Medium", fontSize: "min(24vw, 100px)", lineHeight: "min(24vw, 100px)"}}>
                            {"NEURO"}
                          </div>
                        </div>
                      </div>
                      <div style={{transform: `translateY(${0.6 * currentStepProgress * innerHeight}px)`, opacity: Math.max(0, 1 - currentStepProgress)}}>
                        <div style={{color: "#FFFFFF", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
                          <div style={{width: "85%", maxWidth: 400, letterSpacing: `${currentStepProgress / 2 + 0.065}em`, transform: isHeroLoaded ? `translateY(${0.2 * heroVideoSizePixels}px)` : `scale(0.8) translateY(2vh)`, opacity: isHeroLoaded ? 1 : 0.8, transition: "all 500ms ease-in 400ms", transitionProperty: "opacity, transform, margin-top", fontFamily: "Futura Medium", fontSize: "min(24vw, 100px)", lineHeight: "min(40vw, 100px)"}}>
                            {"FIT"}
                          </div>
                        </div>
                      </div>
                      <CSSTransition
                        timeout={400}
                        classNames={"fade-in-200-delay-200"}
                        unmountOnExit
                        in={!isHeroLoaded}
                      >
                        <div style={{display: "flex", justifyContent: "center", marginTop: "3vh", width: "100%"}}>
                          <div style={{width: "85%", maxWidth: 400, transform: "scale(0.8)", height: 5, borderRadius: 3, overflow: "hidden", backgroundColor: "#555", boxShadow: "0px 0px 1.5px 0.5px #EDEEF2"}}>
                            <div style={{height: "100%", width: `${heroVideoDownloadProgress * 100}%`, transition: "width 200ms ease-out", backgroundColor: "#FFFFFF"}}>
                            </div>
                          </div>
                        </div>
                      </CSSTransition>
                      <div style={{marginTop: "3vh", transform: `translateY(${0.6 * currentStepProgress * innerHeight}px)`, opacity: Math.max(0, 1 - currentStepProgress * 4)}}>
                        <div style={{color: "#EDEEF2", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", pointerEvents: "none"}}>
                          <div style={{width: "85%", maxWidth: 600, opacity: isHeroLoaded ? 1 : 0, transform: isHeroLoaded ? `translateY(${0.2 * heroVideoSizePixels}px)` : "translateY(-40px) scale(0.8)", transition: "all 500ms ease-in 400ms", transitionProperty: "transform, opacity", fontFamily: "Futura", fontSize: "min(6vw, 32px)"}}>
                            {"Welcome to NEUROFIT: a breakthrough nervous system coach backed by data and trusted by leading health experts."}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 1) && (
                  <div style={{display: "flex", height: "100%", width: "100%", justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", color: "#EDEEF2", maxWidth: 500}}>
                      <div style={{display: "flex", height: "100%", width: "100%", marginTop: innerHeight * 0.6 + 60, flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{fontSize: "min(6vw, 26px)", color: "#a5a8b0", fontFamily: "Futura", opacity: (1.2 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`,}}>
                          <span>{"The "}</span>
                          <span style={{color: "#FFFFFF", fontFamily: "Futura Medium"}}>{" guided nervous system program "}</span>
                          <span>{"is designed for highly effective + simple stress relief."}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 2) && (
                  <div style={{display: "flex", height: "100%", width: "100%", justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", color: "#EDEEF2", maxWidth: 500}}>
                      <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{fontSize: "min(6vw, 26px)", color: "#a5a8b0", marginTop: innerHeight * 0.6 + 60, fontFamily: "Futura", opacity: (1.2 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`,}}>
                          <span>{"The "}</span>
                          <span style={{color: "#FFFFFF", fontFamily: "Futura Medium"}}>{" smart exercise library "}</span>
                          <span>{"matches you with exercises that relieve stress in just 2-3 minutes."}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 3) && (
                  <div style={{display: "flex", height: "100%", width: "100%", justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", color: "#EDEEF2", maxWidth: 500}}>
                      <div style={{display: "flex", height: "100%", width: "100%", marginTop: innerHeight * 0.6 + 60, flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{fontSize: "min(6vw, 26px)", color: "#a5a8b0", fontFamily: "Futura", opacity: (1.2 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`,}}>
                          <span style={{color: "#FFFFFF", fontFamily: "Futura Medium"}}>{"Camera-based HRV tech"}</span>
                          <span>{" lets you measure progress and recovery without a wearable."}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 4) && (
                  <div style={{display: "flex", height: "100%", width: "100%", justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", color: "#EDEEF2", maxWidth: 500}}>
                      <div style={{display: "flex", height: "100%", width: "100%", marginTop: innerHeight * 0.6 + 60, flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{fontSize: "min(6vw, 26px)", color: "#a5a8b0", fontFamily: "Futura", opacity: (1.2 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`,}}>
                          <span style={{color: "#FFFFFF", fontFamily: "Futura Medium"}}>{"Personalized insights"}</span>
                          <span>{" help you feel better faster, by pinpointing what your body needs most."}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 5) && (
                  <div style={{display: "flex", height: "100%", width: "100%", justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", color: "#EDEEF2", maxWidth: 500}}>
                      <div style={{display: "flex", height: "100%", width: "100%", marginTop: innerHeight * 0.6 + 60, flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{fontSize: "min(6vw, 26px)", color: "#a5a8b0", fontFamily: "Futura", opacity: (1.2 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`}}>
                          <span>{"The "}</span>
                          <span style={{color: "#FFFFFF", fontFamily: "Futura Medium"}}>{" AI breakthrough coach "}</span>
                          <span>{"provides highly-tailored support while preserving your privacy."}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 6) && (
                  <div style={{display: "flex", height: "100%", width: "100%", marginTop: 60, justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: "85%", maxWidth: 700}}>
                      <div style={{color: "#FFFFFF", display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{width: "100%", transition: "opacity 150ms ease-out", transitionProperty: "opacity, transform", opacity: currentStepProgress > 0 ? 1 : 0, transform: currentStepProgress > 0 ? "none" : "scale(0.9)"}}>
                          <div style={{display: "inline-block", marginTop: "4vh", fontSize: "min(9vw, 60px)", textAlign: "center", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                            {"Recommended By Hundreds Of Health Experts"}
                          </div>
                        </div>
                        <div style={{width: "100%", opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`}}>
                          {HealthProfessionals.map(obj => (
                            <div style={{display: "inline-block", fontFamily: "Futura Medium", fontSize: obj.fontSize, padding: obj.padding}}>
                              {obj.name}
                            </div>
                          ))}
                        </div>
                        <div/>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 7) && (
                  <div style={{display: "flex", height: "100%", width: "100%", marginTop: 60, justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: isMobile ? "85%" : "100%", maxWidth: isMobile ? 450 : undefined}}>
                      <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{color: "#FFFFFF", transition: "all 200ms ease-in", transitionProperty: "opacity, transform", opacity: currentStepProgress > 0 ? 1 : 0, transform: currentStepProgress > 0.05 ? "none" : "scale(0.9)"}}>
                          <div style={{fontSize: "min(9vw, 60px)", marginTop: "4vh", textAlign: "center", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                            <div>{"Built For Performance"}</div>
                          </div>
                        </div>
                        {isMobile ? (
                          <div style={{opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress)}px)`}}>
                            <div style={{color: "#FFFFFF"}}>
                              <div style={{display: "inline-block", fontSize: "min(40vw, 200px)", lineHeight: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"96%"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", maxWidth: 450, marginTop: "1vh", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`of users relieve real-time stress within 5 minutes of NEUROFIT Training¹`}</span>
                              </div>
                            </div>
                            <div style={{transition: "all 300ms ease-out", color: "#FFFFFF", marginTop: "3vh"}}>
                              <div style={{display: "inline-block", fontSize: "min(40vw, 200px)", lineHeight: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"54%"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", maxWidth: 450, marginTop: "1vh", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`average stress reduction after 1 week for active members²`}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress)}px)`, display: "flex", justifyContent: "space-evenly", alignItems: "center"}}>
                            <div style={{color: "#FFFFFF", maxWidth: 400}}>
                              <div style={{display: "inline-block", fontSize: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"96%"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`of users relieve real-time stress in just 5 minutes of NEUROFIT Training¹`}</span>
                              </div>
                            </div>
                            <div style={{color: "#FFFFFF", maxWidth: 400}}>
                              <div style={{display: "inline-block", fontSize: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"54%"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`average stress reduction after 1 week for active members²`}</span>
                              </div>
                            </div>
                          </div>
                        )}
                        <div/>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 8) && (
                  <div style={{display: "flex", height: "100%", width: "100%", marginTop: 60, justifyContent: "center", opacity: (currentStepProgress > 0 && currentStepProgress < 1) ? 1 : 0, transition: "opacity 200ms ease-in"}}>
                    <div style={{width: isMobile ? "85%" : "100%", maxWidth: isMobile ? 450 : undefined}}>
                      <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{color: "#FFFFFF", transition: "all 200ms ease-in", transitionProperty: "opacity, transform", opacity: currentStepProgress > 0 ? 1 : 0, transform: currentStepProgress > 0.05 ? "none" : "scale(0.9)"}}>
                          <div style={{fontSize: "min(9vw, 60px)", marginTop: "4vh", textAlign: "center", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                            <div>{"Science-Based, Data-Driven"}</div>
                          </div>
                        </div>
                        {isMobile ? (
                          <div style={{opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress)}px)`}}>
                            <div style={{color: "#FFFFFF"}}>
                              <div style={{display: "inline-block", fontSize: "min(40vw, 200px)", lineHeight: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"7M+"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", maxWidth: 450, marginTop: "1vh", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{"in-app datapoints validate "}</span>
                                <span style={{fontFamily: "Futura Medium"}}>{"Nervous System Fitness"}</span>
                                <sup style={{fontFamily: "Futura Medium"}}>{"®"}</sup>
                                <span>{"³"}</span>
                              </div>
                            </div>
                            <div style={{transition: "all 300ms ease-out", color: "#FFFFFF", marginTop: "3vh"}}>
                              <div style={{display: "inline-block", fontSize: "min(40vw, 200px)", lineHeight: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"20+"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", maxWidth: 450, marginTop: "1vh", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`leading university studies inform the NEUROFIT method⁴`}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress)}px)`, display: "flex", justifyContent: "space-evenly", alignItems: "center"}}>
                            <div style={{color: "#FFFFFF", maxWidth: 400}}>
                              <div style={{display: "inline-block", fontSize: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"7M+"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{"in-app datapoints validate "}</span>
                                <span style={{fontFamily: "Futura Medium"}}>{"Nervous System Fitness"}</span>
                                <sup style={{fontFamily: "Futura Medium"}}>{"®"}</sup>
                                <span>{"³"}</span>
                              </div>
                            </div>
                            <div style={{color: "#FFFFFF", maxWidth: 400}}>
                              <div style={{display: "inline-block", fontSize: "min(33vw, 200px)", textAlign: "start", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                                {"20+"}
                              </div>
                              <div style={{fontSize: "min(5vw, 25px)", textAlign: "start", fontFamily: "Futura"}}>
                                <span>{`leading university studies inform the NEUROFIT method⁴`}</span>
                              </div>
                            </div>
                          </div>
                        )}
                        <div/>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 9) && (
                  <div style={{display: "flex", height: "100%", width: "100%", marginTop: 60, justifyContent: "center"}}>
                    <div style={{width: "85%", maxWidth: 700}}>
                      <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{color: "#FFFFFF", transition: "all 200ms ease-in", transitionProperty: "opacity, transform", opacity: currentStepProgress > 0 ? 1 : 0, transform: currentStepProgress > 0.05 ? "none" : "scale(0.9)"}}>
                          <div style={{fontSize: "min(9vw, 60px)", marginTop: "4vh", textAlign: "center", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                            <div>{"Beat Stress Fast With Nervous System Fitness"}<sup>{"®"}</sup></div>
                          </div>
                        </div>
                        <div style={{opacity: (1.3 - (Math.abs(currentStepProgress - 0.5) * 2.0)), transform: `translateY(${-40 * (currentStepProgress - 0.5)}px)`}}>
                          <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "space-around"}}>
                            <img src="/images/shape-groundbreaking-recovery-innovations-white.webp?v=3" style={{width: "calc(86% * 0.908)", maxWidth: 400 * 0.908}} alt="NEUROFIT is a 2023 SHAPE Magazine Groundbreaking Recovery Innovation." />
                          </div>
                          <div style={{display: "flex", marginTop: "3vh", width: "100%", alignItems: "center", justifyContent: "space-around"}}>
                            <img src="/images/well-and-good-laurel-white.webp?v=2" style={{width: "86%", maxWidth: 400}} alt="NeuroFit eased my stress in ways meditation never has -Well and Good" />
                          </div>
                          <div style={{textAlign: "center", margin: "3vh auto", opacity: 1}}>
                            <div>
                              <StarRatings
                                disabled
                                rating={4.8}
                                starRatedColor={"#FFFFFF"}
                                starEmptyColor={"#CFD2DD"}
                                starDimension={"min(8vw, 40px)"}
                                starSpacing={"min(2vw, 10px)"}
                                numberOfStars={5}
                              />
                            </div>
                            <div style={{display: "inline-block", color: "#FFFFFF", fontSize: "min(5vw, 26px)", textAlign: "start", fontFamily: "Futura Medium", marginInlineEnd: "0.3em", textTransform: "uppercase"}}>
                              {"4.8/5 App Store Rating"}
                            </div>
                          </div>
                        </div>
                        <div/>
                      </div>
                    </div>
                  </div>
                )}
                {(currentStepIndex === 10) && (
                  <div style={{display: "flex", height: "100%", width: "100%", marginTop: 60, justifyContent: "center"}}>
                    <div style={{width: "100%", maxWidth: 700}}>
                      <div style={{display: "flex", height: "100%", width: "100%", flexDirection: "column", justifyContent: "space-between"}}>
                        <div style={{color: "#FFFFFF", zIndex: 2, transition: "all 200ms ease-in", transitionProperty: "opacity, transform", opacity: currentStepProgress > 0 ? 1 : 0, transform: currentStepProgress > 0.05 ? "none" : "scale(0.9)"}}>
                          <div style={{fontSize: "min(9vw, 60px)", marginTop: "4vh", textAlign: "center", fontFamily: "Futura Medium", textTransform: "uppercase"}}>
                            <div>{"DOWNLOAD NOW"}</div>
                          </div>
                        </div>
                        <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                          <div style={{width: heroVideoSizePixels, transform: `scale(${Math.min(1.2, 1.0 + currentStepProgress * 0.2)})`, height: heroVideoSizePixels, opacity: Math.min(Math.abs(currentStepProgress * 1.4), 1.0)}}>
                            <ScrollAnimatedHeroImageContainer
                              featureImagePaths={[
                              ]}
                              heroImagePath={"/assets/animations/lp-phone-flip/phone-silver-program.webp"}
                              currentImageIndex={0}
                              currentImageProgress={0}
                            />
                          </div>
                        </div>
                        <div style={{height: "10vh"}}/>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Scrollama
                offset={0}
                onStepEnter={({data}) => {
                  this.setState({currentStepIndex: data, currentStepProgress: (currentStepIndex !== data) ? ((data > currentStepIndex) ? 0 : 1) : currentStepProgress})
                }}
                onStepProgress={({data, progress}) => {
                  this.setState({currentStepIndex: data, currentStepProgress: progress})
                }}
                debug={false}
              >
                {[{heightScale: 1.0}, {heightScale: 1.0}, {heightScale: 1.0}, {heightScale: 1.0}, {heightScale: 1.0}, {heightScale: 1.0}, {heightScale: 1}, {heightScale: 1}, {heightScale: 1}, {heightScale: 1}, {heightScale: 1}].map((config, stepIndex) => (
                  <Step data={stepIndex} key={stepIndex}>
                    <div
                      id={`scrollama-step-${stepIndex}`}
                      style={{
                        height: config.heightScale * innerHeight,
                        marginBottom: 0.05 * innerHeight,
                        pointerEvents: "none",
                        // border: '1px solid gray',
                        opacity: currentStepIndex === stepIndex ? 1 : 0.2,
                      }}
                    >
                    </div>
                  </Step>
                ))}
              </Scrollama>
            </div>
          </div>
        </div>
        <QrCodeDownloadModal
          show={showQrCodeModal}
          onHide={() => this.setState({showQrCodeModal: false})}
          safeAreaInsets={safeAreaInsets}
        />
        <LandingPageLinksModal
          show={showSettingsModal}
          onHide={() => this.setState({showSettingsModal: false})}
          onClickDownloadAppButton={() => {
            recordPixelEventIfAvailable("StartTrial")
            recordLinkClickAndRedirect(GA_LABEL_CLICKED_APP_DOWNLOAD_LINK, appDownloadUrl)
          }}
          onClickTrainerCertificationButton={() => {
            recordLinkClickAndRedirect(GA_LABEL_CLICKED_CERTIFICATION_BUTTON, "/certification")
          }}
          onClickQuizButton={() => {
            recordPixelEventIfAvailable("Lead")
            recordLinkClickAndRedirect(GA_LABEL_CLICKED_QUIZ_BUTTON, "/quiz")
          }}
          safeAreaInsets={safeAreaInsets}
        />
      </div>
    )
  }
}

export default LandingPageV2;